import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { put } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import '../customers/CustomerModals.scss'

function ToggleBusinessActivation({
  businessId,
  orgName,
  isActive,
  onSuccess,
  onClose,
}: any) {
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)
  const [reason, setReason] = useState('')

  const isDeactivating = isActive !== false

  async function confirm() {
    setLoading(true)
    const endpoint = isDeactivating
      ? `admin/business/${businessId}/deactivate`
      : `admin/business/${businessId}/reactivate`
    const body = isDeactivating ? { reason: reason.trim() || undefined } : null
    put(endpoint, body)
      .then((result: any) => {
        if (result.success) {
          notify('success', result.message)
          onSuccess(result.data.active)
          onClose()
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <Modal position='center'>
      <div className='customer-modal'>
        <div className='modal-header'>
          <div
            className={`modal-icon ${isDeactivating ? 'icon-red' : 'icon-green'}`}
          >
            <Icon
              icon={
                isDeactivating
                  ? 'mdi:domain-remove'
                  : 'mdi:domain-plus'
              }
            />
          </div>
          <h2>{isDeactivating ? 'Deactivate' : 'Reactivate'} Business</h2>
          <p>
            {isDeactivating
              ? `${orgName || 'This business'} will be blocked immediately — their API keys will stop working, they will not be able to create shipments and their team will be locked out of the business dashboard until reactivated.`
              : `${orgName || 'This business'} will regain full access — their API keys will work again and their team can log back into the business dashboard.`}
          </p>
        </div>

        <div
          className={`status-indicator ${isActive === false ? 'status-off' : 'status-on'}`}
        >
          <div className='dot' />
          <p>
            Current status:{' '}
            <span>{isActive === false ? 'Deactivated' : 'Active'}</span>
          </p>
        </div>

        {isDeactivating && (
          <div className='form-group'>
            <label>Reason (optional)</label>
            <textarea
              rows={3}
              placeholder='e.g. fraudulent activity, unpaid debt...'
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        )}

        {loading ? (
          <FormLoader position='center' />
        ) : (
          <div className='modal-actions'>
            <button className='btn-cancel' onClick={onClose}>
              Cancel
            </button>
            <button
              className={isDeactivating ? 'btn-danger' : 'btn-proceed'}
              onClick={confirm}
            >
              {isDeactivating ? 'Deactivate' : 'Reactivate'}
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default ToggleBusinessActivation
